import * as React from "react";

import "./styles.scss";

const LoaderContext = React.createContext();

const LoaderContextComponent = ({ children }) => {
  const [isLoading, setIsLoading] = React.useState(false);

  return (
    <LoaderContext.Provider
      value={{
        isLoading,
        setIsLoading,
      }}
    >
      {isLoading && (
        <div id="AppLoader">
          <div className="svg-loader">
            <svg
              className="svg-container"
              height="100"
              width="100"
              viewBox="0 0 100 100"
            >
              <circle className="loader-svg bg" cx="50" cy="50" r="45"></circle>
              <circle
                className="loader-svg animate"
                cx="50"
                cy="50"
                r="45"
              ></circle>
            </svg>
          </div>
        </div>
      )}
      {children}
    </LoaderContext.Provider>
  );
};

const useLoader = () => {
  const { isLoading, setIsLoading } = React.useContext(LoaderContext);

  return { isLoading, setIsLoading };
};

export { useLoader, LoaderContextComponent as LoaderContext };
